<template>
  <div>
    <div class="menu" ref="menu">
      <Menu :bus="bus"/>
    </div>
    <div class="home fullpage" ref="fullpage">
      <div class="section" data-anchor="page">
        <Banner
          :bus="bus"
          class="home_banner_1 mainchild"
          :pageable="pageable"
          :afterscroller="require(`@/assets/img/citazioni_${$i18n.locale}.svg`)"
          v-bind:bgvideo="require(`@/assets/img/bannervideo.mp4`)"
        >
          <div class="container">
            <div class="col-md-10 mx-auto">
              <Title v-bind:title="$t('home.title')" v-bind:main="true"></Title>
            </div>
          </div>
        </Banner>
      </div>
      <div class="section" data-anchor="page">
        <div class>
          <Hero
            :bus="bus"
            class="home_hero_1 mainchild"
            v-bind:title="$t('home.banner1.title')"
            v-bind:text="$t('home.banner1.text')"
            v-bind:bgimage="require(`@/assets/img/chi-siamo.jpg`)"
          >
            <div v-if="$i18n.locale != 'fr'">
              <router-link :to="{ name: $i18n.locale + '.about'}" class="btn btn-primary">
                {{ $t('readmore') }}
              </router-link>
            </div>
          </Hero>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec1.title')"
              v-bind:text="$t('home.sec1.text')"
              v-bind:images="[require(`@/assets/img/ricerca.jpg`)]"
            >
            <div v-if="$i18n.locale != 'fr'">
              <router-link :to="{ name: $i18n.locale + '.research'}" class="btn btn-primary">
                {{ $t('readmore') }}
              </router-link>
            </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec2.title')"
              v-bind:text="$t('home.sec2.text')"
              v-bind:isInvert="true"
              v-bind:video="require(`@/assets/img/progettazione.mp4`)"
            >
              <div v-if="$i18n.locale != 'fr'">
                <router-link :to="{ name: $i18n.locale + '.design'}" class="btn btn-primary">
                  {{ $t('readmore') }}
                </router-link>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec3"
              v-bind:title="$t('home.sec3.title')"
              v-bind:text="$t('home.sec3.text')"
              v-bind:images="[require(`@/assets/img/realizzazione 1.gif`), require(`@/assets/img/realizzazione 2.gif`)]"
            >
              <div v-if="$i18n.locale != 'fr'">
                <router-link :to="{ name: $i18n.locale + '.development'}" class="btn btn-primary">
                  {{ $t('readmore') }}
                </router-link>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec4.title')"
              v-bind:text="$t('home.sec4.text')"
              v-bind:isInvert="true"
              v-bind:bgvideo="require(`@/assets/img/produzione_background.mp4`)"
            >
              <div v-if="$i18n.locale != 'fr'">
                <router-link :to="{ name: $i18n.locale + '.production'}" class="btn btn-primary">
                  {{ $t('readmore') }}
                </router-link>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec6"
              v-bind:isInvert="true"
              v-bind:title="$t('home.sec6.title')"
              v-bind:text="$t('home.sec6.text')"
              :bgimage="require(`@/assets/img/Sostenibilita-background.jpg`)"
              v-bind:images="[require(`@/assets/img/sostenibilita-slide-1.jpg`), require(`@/assets/img/sostenibilita-slide-2.jpg`)]"
            >
              <div v-if="$i18n.locale != 'fr'">
                <router-link :to="{ name: $i18n.locale + '.sustainability'}" class="btn btn-primary">
                  {{ $t('readmore') }}
                </router-link>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec5"
              v-bind:text="$t('home.sec5.text')"
              v-bind:images="[require(`@/assets/img/Collaborazioni.jpg`), require(`@/assets/img/Collaborazioni-2.jpg`), require(`@/assets/img/parigi-1.jpg`), require(`@/assets/img/parigi-2.jpg`), require(`@/assets/img/parigi-3.jpg`)]"
            >
              <div>
                <a href="https://www.ifmparis.fr/en/" target="_blank" rel="noopener">
                  <img class="mt-4 d-flex mx-auto" src="@/assets/img/institut.png">
                </a>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import Banner from "@/components/Banner";
import Hero from "@/components/Hero";
import ImgText from "@/components/ImgText";
import Title from "@/components/Title";
import Menu from "@/components/Menu";
import MainForm from "@/components/form/MainForm";
import Footer from "@/components/Footer";
import fullpage from "fullpage.js";

export default {
  name: "home",
  data() {
    return {
      pageable: Function,
      currpageIdx: Number,
      currpageEl: HTMLElement,
      bus: new Vue()
    };
  },
  components: {
    Menu,
    Banner,
    Hero,
    ImgText,
    Title,
    MainForm,
    Footer
  },
  mounted() {

    this.$nextTick(() => {

      {
        let id = 0;
        for (let el of this.$el.querySelectorAll('[data-anchor="page"]')) {
          el.setAttribute("data-anchor", "page" + id++);
        }
      }

      this.pageable = new fullpage(this.$refs.fullpage, {
        responsiveWidth: 576,
        responsiveHeight: 600,
        menu: ".menu",
        onLeave: (origin, destination, direction) => {
          this.bus.$emit("pagechanging", this.currpageEl, destination);
        },
        afterLoad: (origin, destination, direction) => {
          this.currpageIdx = destination.index;
          this.currpageEl = this.$refs.fullpage.children[
            this.currpageIdx
          ].querySelector(".mainchild");

          this.bus.$emit("pagechange", this.currpageEl);
        }
      });
    });
  },
  beforeDestroy() {
    console.log('destroy')
    fullpage_api.destroy('all')
  }
};
</script>


<style lang="scss">
@import "pageable/src/pageable.scss";

.fp-responsive .fp-section,
.fp-responsive .fp-tableCell {
  height: auto !important;
}

.max-width-100 {
  max-width: 100%;
}
.fp-section .container {
  transition: opacity 0.1s
}
.fp-section:not(.active) .container {
  @include media-breakpoint-up(md) {
    opacity: 0 !important;
  }
}
.fp-section {

  @media (max-height: 599px) {
    &, .fp-tableCell, .fp-tableCell > div, .hero {
      min-height: 100vh;
    }
  }
}
</style>

<style scoped lang="scss">
.section {
  position: relative;
}
.home_banner_1,
.black_sections {
  background: black;
  color: white;
  /deep/ a {
    color: white;
    text-decoration: underline;
  }
}

.fp-tableCell,
.home_hero_1,
.home_hero_1 /deep/ .bg,
.home_banner_1 {
  @include media-breakpoint-down(sm) {
    min-height: 100vh;
  }
}

.home_hero_1 /deep/ .col-sm-6:first-child {
  flex: 100%;
  max-width: 100%;
  margin-bottom: 30px;
}
.home_hero_1 /deep/ .bg {
  background-size: cover;
}

.fp-tableCell > div > div > div {
  @include media-breakpoint-down(sm) {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

.black_sections /deep/ p {
  color: white;
}
.black_sections /deep/ strong {
  color: white;
}

.fp-tableCell > div,
.pg-page > .banner,
.pg-page > .banner,
.pg-container > .section > div:not(.footer) {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pg-page > .banner {
  justify-content: space-around;
}

.home_hero_1 /deep/ p {
  color: black;
}

.home_sec3 /deep/ .imgtext__box svg {
  width: 75%;
  height: 96%;
}
.home_sec6 /deep/ h3 {
  font-size: 21px;
}
.home_sec6 /deep/ p {
  color: black;
  font-size: 13px;
}
.home_sec6 /deep/ .title {
  color: black;
  text-shadow: none;
}
.home_sec6 /deep/ .imgtext__text {
  padding-top: 0;
}
.home_sec5 /deep/ .imgtext__text {
  padding-top: 30px;
}
.home_sec5 /deep/ .imgtext__text > div {
  display: flex;
  flex-direction: column;
  > div:last-child {
    order: 1;
    margin-bottom: 30px;
  }
  > p:first-child {
    order: 2;
  }
}

</style>
